import 'css-chunksrc/client/pages/projectPage/discussionsPage/discussions/discussion/chatInput/styles.scss';export default {
  "form": "_form_1ozxo_1",
  "chatInput": "_chatInput_1ozxo_11",
  "noBorder": "_noBorder_1ozxo_20",
  "main": "_main_1ozxo_26",
  "group": "_group_1ozxo_34",
  "input": "_input_1ozxo_42",
  "submitButton": "_submitButton_1ozxo_57",
  "menu": "_menu_1ozxo_61",
  "mention": "_mention_1ozxo_67",
  "footer": "_footer_1ozxo_72",
  "list": "_list_1ozxo_84",
  "iconBox": "_iconBox_1ozxo_91",
  "icon": "_icon_1ozxo_91"
};